import React, { createContext, useContext, useState, useEffect } from 'react';
import { t as translate } from './translations';

const LanguageContext = createContext({ lang: 'en', setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    return localStorage.getItem('app_lang') || '';
  });

  const setLang = (newLang) => {
    localStorage.setItem('app_lang', newLang);
    setLangState(newLang);
  };

  useEffect(() => {
    if (lang) {
      document.documentElement.lang = lang === 'zh' ? 'zh-CN' : 'en';
    }
  }, [lang]);

  const t = (key) => translate(key, lang || 'en');

  return (
    <LanguageContext.Provider value={{ lang: lang || 'en', rawLang: lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
